import { Action, Reducer, Dispatch } from 'redux';
import { CoreClassroomAdminClassroom, CoreClassroomAdminClassroomListing } from '../../models/CoreClassroomAdminClassroom';
import { PageResult } from '../../models/CoreModels';
import { RequestState } from '../../models/RequestState';
import InstanceClient from "../../services/InstanceClient";
import StatusCode from "../../util/StatusCode";
import store from '../store';
import { CoreTracking } from '../../models/CoreTracking';
import { ClassroomAdminClassroomPageRequest } from '../../models/Requests';

 enum ClassroomAdminAClassroomActionType {
     List_Classrooms = "LIST_CLASSROOMS",
     GET_CLASSROOM = 'GET_CLASSROOM',
     GET_CLASSROOM_TRACKINGS = 'GET_CLASSROOM_TRACKINGS',
}

export interface ClassroomAdminClassroomState {
    classrooms: RequestState<PageResult<CoreClassroomAdminClassroomListing>>
    classroom: RequestState<CoreClassroomAdminClassroom>
    classroomTrackings: RequestState<CoreTracking[]>
};

interface ClassroomAdmin_ListClassrooms extends Action<ClassroomAdminAClassroomActionType.List_Classrooms> {
    classrooms: RequestState<PageResult<CoreClassroomAdminClassroomListing>>
};

interface ClassroomAdmin_GetClassroom extends Action<ClassroomAdminAClassroomActionType.GET_CLASSROOM> {
    classroom: RequestState<CoreClassroomAdminClassroom>
};

interface ClassroomAdmin_GetClassroomTrackings extends Action<ClassroomAdminAClassroomActionType.GET_CLASSROOM_TRACKINGS> {
    classroomTrackings: RequestState<CoreTracking[]>
}


type ClassroomAdminClassroomAction = ClassroomAdmin_ListClassrooms
    | ClassroomAdmin_GetClassroom
    | ClassroomAdmin_GetClassroomTrackings;

export const ListClassroomAdminClassroom = (filter: Partial<ClassroomAdminClassroomPageRequest> = {}) => (dispatch: Dispatch<ClassroomAdmin_ListClassrooms>) => {
    dispatch({
        type: ClassroomAdminAClassroomActionType.List_Classrooms,
        classrooms: { code: StatusCode.PENDING }
    })
    const url = '/api/core/classroomadmin/classrooms'
    InstanceClient.get<PageResult<CoreClassroomAdminClassroomListing>>(url,filter)
        .then(res =>
            dispatch({
                type: ClassroomAdminAClassroomActionType.List_Classrooms,
                classrooms: {
                    code: StatusCode.COMPLETE,
                    data: res.data,
                }
            }))
        .catch(error =>
            dispatch({
                type: ClassroomAdminAClassroomActionType.List_Classrooms,
                classrooms: { code: StatusCode.ERROR, error },
            })
    );
};

export const GetClassroom = (id: string) => (dispatch: Dispatch<ClassroomAdmin_GetClassroom>) => {
    const storeKey = store.getState().classroomAdminClassroom.classroom.key;
    if (id === storeKey) {
        return;
    }

    dispatch({
        type: ClassroomAdminAClassroomActionType.GET_CLASSROOM,
        classroom: { code: StatusCode.PENDING, key: id }
    })
    const url = `/api/core/classroomadmin/classroom/${id}`;
    InstanceClient.get<CoreClassroomAdminClassroom>(url)
        .then(res =>
            dispatch({
                type: ClassroomAdminAClassroomActionType.GET_CLASSROOM,
                classroom: {
                    code: StatusCode.COMPLETE,
                    data: res.data,
                    key: id
                }
            }))
        .catch(error =>
            dispatch({
                type: ClassroomAdminAClassroomActionType.GET_CLASSROOM,
                classroom: { code: StatusCode.ERROR, error },
            })
        );
};

export const GetClassroomTrackings = (id: string, update: boolean = false) => (dispatch: Dispatch<ClassroomAdmin_GetClassroomTrackings>) => {
    const storeKey = store.getState().classroomAdminClassroom.classroomTrackings?.key;
    if (id === storeKey && !update) {
        return;
    }
    dispatch({
        type: ClassroomAdminAClassroomActionType.GET_CLASSROOM_TRACKINGS,
        classroomTrackings: { code: StatusCode.PENDING }
    })
    InstanceClient.get<CoreTracking[]>(`/api/core/classroomadmin/classroom/${id}/trackings`)
        .then(res =>
            dispatch({
                type: ClassroomAdminAClassroomActionType.GET_CLASSROOM_TRACKINGS,
                classroomTrackings: { code: StatusCode.COMPLETE, data: res.data, key: id }
            })
        )
        .catch(error =>
            dispatch({
                type: ClassroomAdminAClassroomActionType.GET_CLASSROOM_TRACKINGS,
                classroomTrackings: { code: StatusCode.ERROR, error }
            })
        );
};


const initialState: ClassroomAdminClassroomState = {
    classrooms: { code: StatusCode.NONE },
    classroom: { code: StatusCode.NONE },
    classroomTrackings: { code: StatusCode.NONE },
}
export const reducer: Reducer<ClassroomAdminClassroomState, ClassroomAdminClassroomAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case ClassroomAdminAClassroomActionType.List_Classrooms:
            return {
                ...state,
                classrooms: action.classrooms
            };
        case ClassroomAdminAClassroomActionType.GET_CLASSROOM:
            return {
                ...state,
                classroom: action.classroom
            };
        case ClassroomAdminAClassroomActionType.GET_CLASSROOM_TRACKINGS:
            return {
                ...state,
                classroomTrackings: action.classroomTrackings
            };
        default:
            return state;
    }
};